export class Itemuom {
    itemuomid: number;
    uom: string;
}